export default __webpack_public_path__ + "static/media/search-2.d83d611e.svg";